module.exports = __webpack_public_path__ + "img/view.5914300f.svg";